import common from './common.json';
import components from './components.json';
import appointment from './appointment.json';
import gallery from './gallery.json';
import time from './time.json';
import workingScale from './workingScale.json';
import account from './account.json';
import landingPage from './landingPage.json';
import login from './login.json';
import passwordRecovery from './passwordRecovery.json';
import register from './register.json';
import shoppingCart from './shoppingCart.json';
import cartPayment from './cartPayment.json';
import employee from './employee.json';
import searchPage from './searchPage.json';
import servicePage from './servicePage.json';
import storePage from './storePage.json';
import employeesPage from './employeesPages.json'
import myWorkscales from './myWorkscales.json'
import orderDetails from './orderDetails.json'

const ptbr = {
    ...common,
    components: components,
    appointmentDetails: appointment,
    imageGallery: gallery,
    timeRange: time,
    workingScale: workingScale,
    accountDetails: account,
    landingPage: landingPage,
    login: login,
    passwordRecovery: passwordRecovery,
    register: register,
    shoppingCart: shoppingCart,
    cartPayment: cartPayment,
    employeePage: employee,
    searchPage: searchPage,
    servicePage: servicePage,
    storePage: storePage,
    employeesPages: employeesPage,
    myWorkscales: myWorkscales,
  orderDetails: orderDetails,
};

export default ptbr;